<template>
  <div id="companies">
    <div id="container">
      <datatablevue
        v-show="companies.loaded && companies.error === null"
        :items="companies.data"
        :tableSettings="tableData"
        :searchSettings="searchSettings">
      </datatablevue>

      <div class="loader" v-if="!companies.loaded"></div>

      <transition name="fade">
        <div class="box" v-if="companies.loaded && companies.error === null && total_pages > 1">
            <div class="content">
              <pagination
                :current_page="current_page"
                :total_pages="total_pages"
                :next="nextPage"
                :set="setPage"
                :prev="prevPage">
              </pagination>
            </div>
        </div>
      </transition>

    </div>
  </div>
</template>

<script>
import { Companies } from '@/services/api/ApiRoutes';

export default {
  name: 'AllCompanies',

  data() {
    // Set page title
    this.$parent.title.heading = this.$t('companies');
    this.$parent.title.subheading = this.$parent.pickRandom(this.$t('companies-tagline'));

    const tableData = {
      columns: [
        {
          heading: this.$t('company-name'),
          value: 'name'
        },
        {
          heading: this.$t('email'),
          value: 'email'
        },
        {
          heading: this.$t('city'),
          value: function city(company) {
              return company.address.city;
          },
        },
        {
          heading: this.$t('address'),
          value: function adress(company) {
            return `${company.address.street} ${company.address.number}`;
          },
        }
      ],
      activeColumns: [0, 1, 3],
      link(company) {
        return `/companies/${company._id}`;
      },
    };

    return {
      tableData,
      companies: {
        error: null,
        data: [],
        loaded: false,
      },
      searchSettings: {
        searchQuery: '',
        searchLoading: false,
        searchCallback: this.searchCompanies,
        noneMessage: this.$t('no-entities-found', { entity: this.$t('companies').toLowerCase() })
      },
      per_page: 50,
      current_page: this.$route.query.page || 1,
      total_pages: 1,
    };
  },

  mounted() {
    this.searchSettings.searchQuery = this.$route.query.query || '';
    this.getCompanies();
  },

  methods: {
    getCompanies() {
      const query = (this.searchSettings.searchQuery.length > 0) ? { _sort: 'name', q: this.searchSettings.searchQuery } : { _sort: 'name' };

      Companies.getPaged(this.per_page, this.current_page, query).then((companies) => {
        this.companies.error = null;
        this.companies.data = companies.items;
        this.companies.loaded = true;
        this.total_pages = Math.ceil(companies.total_count / this.per_page);
        this.searchSettings.searchLoading = false;

        if (this.total_pages <= 0) return;
        if (this.current_page > this.total_pages) this.setPage(this.total_pages, true);
        if (this.current_page < 1) this.setPage(1, true);
      }).catch((error) => {
        this.companies.error = error;
        this.companies.loaded = true;
      });
    },

    nextPage() {
      if (this.current_page === this.total_pages) return;

      this.$parent.scrollToTop();
      this.current_page = parseInt(this.current_page, 10) + 1;
      this.rebuildUrl();
      this.getCompanies();
    },

    setPage(page, force) {
      if ((this.current_page > this.total_pages || this.current_page < 0) && !force) return;

      this.$parent.scrollToTop();
      this.current_page = parseInt(page, 10);
      this.rebuildUrl();
      this.getCompanies();
    },

    prevPage() {
      if (this.current_page <= 1) return;

      this.$parent.scrollToTop();
      this.current_page = parseInt(this.current_page, 10) - 1;
      this.rebuildUrl();
      this.getCompanies();
    },

    searchCompanies(query) {
      this.searchSettings.searchQuery = query;

      this.getCompanies();
      this.rebuildUrl();
    },

    rebuildUrl() {
      let url = '/companies?';
      if (this.searchSettings.searchQuery.length > 0) url += `&query=${this.searchSettings.searchQuery}`;
      if (this.current_page !== 1) url += `&page=${this.current_page}`;

      this.$router.push(url);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/companies/Companies.vue